<template>
  <div id="app">
    <app-header></app-header>
    <section class="w-100 d-flex flex-row section-1">
      <app-navigation></app-navigation>
      <section class="d-flex flex-column justify-content-between section-2">
        <router-view></router-view>
        <app-footer></app-footer>
      </section>
    </section>
  </div>
</template>

<script>
import Header from './components/shared/Header'
import Footer from './components/shared/Footer'
import Navigation from './components/shared/Navigation'

export default {
  name: 'App',
  components: {
    AppHeader: Header,
    AppFooter: Footer,
    AppNavigation: Navigation
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">
#app{
  & > section.section-1{
    & > section.section-2{
      padding-left: 1rem;
      padding-right: 1rem;
      width: 100%;
      height: 90vh;
    }
  }
}

/* Start Colors */

// color variables
:root {
  --color-forest-green: rgba(40, 167, 69, 1);
  --color-light-gray: rgba(229, 222, 222, 1);
  --color-chestnut-rose: rgba(212, 106, 106, 1);
  --color-floral-white: rgba(255, 250, 240, 1);
  --color-white: rgba(255, 255, 255, 1);
  --color-black: rgba(0, 0, 0, 1);
  --color-curious-blue: rgba(34, 134, 195, 1);
  --color-baby-blue: rgba(155, 231, 255, 1);
  --color-maya-blue: rgba(100, 181, 246, 1);
  --color-linkedin: rgba(14, 118, 168, 1);
  --color-instagram: rgba(255, 165, 0, 1);
  --color-facebook: rgba(59, 89, 152, 1);
  --color-google-plus: rgba(211, 72, 54, 1);
  --color-apropos-section-1: rgba(23, 162, 184, 1);
  --color-apropos-section-2: rgba(212, 106, 106, 1);
  --color-apropos-section-3: rgba(40, 167, 69, 1);
  --color-apropos-section-4: rgba(232, 62, 140, 1);
  --color-apropos-section-5: rgba(32, 201, 151, 1);
}

// color classes
.color-forest-green {color: var(--color-forest-green, #28A745)};
.color-light-gray {color: var(--color-light-gray, #E5DEDE)};
.color-chestnut-rose {color: var(--color-chestnut-rose, #D46A6A)};
.color-floral-white {color: var(--color-floral-white, #FFFAF0)};
.color-white {color: var(--color-white, #FFFFFF)};
.color-black {color: var(--color-black, #000000)};
.color-curious-blue {color: var(--color-curious-blue, #2286C3)};
.color-baby-blue {color: var(--color-baby-blue, #9BE7FF)};
.color-maya-blue {color: var(--color-maya-blue, #64B5F6)};
.color-linkedin {color: var(--color-linkedin, #0e76a8)}
.color-instagram {color: var(--color-instagram, #FFA500)}
.color-facebook {color: var(--color-facebook, #3b5998)}
.color-google-plus {color: var(--color-google-plus, #d34836)}
.color-apropos-section-1 {color: var(--color-apropos-section-1, #17A2B8)}
.color-apropos-section-2 {color: var(--color-apropos-section-2, #D46A6A)}
.color-apropos-section-3 {color: var(--color-apropos-section-3, #28A745)}
.color-apropos-section-4 {color: var(--color-apropos-section-4, #E83E8C)}
.color-apropos-section-5 {color: var(--color-apropos-section-5, #20C997)}

// background-color classes
.bg-color-forest-green {background-color: var(--color-forest-green, #28A745)};
.bg-color-light-gray {background-color: var(--color-light-gray, #E5DEDE)};
.bg-color-chestnut-rose {background-color: var(--color-chestnut-rose, #D46A6A)};
.bg-color-floral-white {background-color: var(--color-floral-white, #FFFAF0)};
.bg-color-white {background-color: var(--color-white, #FFFFFF)};
.bg-color-black {background-color: var(--color-black, #000000)};
.bg-color-curious-blue {background-color: var(--color-curious-blue, #2286C3)};
.bg-color-baby-blue {background-color: var(--color-baby-blue, #9BE7FF)};
.bg-color-maya-blue {background-color: var(--color-maya-blue, #64B5F6)};
.bg-color-linkedin {background-color: var(--color-linkedin, #0e76a8)}
.bg-color-instagram {background-color: var(--color-instagram, #FFA500)}
.bg-color-facebook {background-color: var(--color-facebook, #3b5998)}
.bg-color-google-plus {background-color: var(--color-google-plus, #d34836)}
.bg-color-apropos-section-1 {background-color: var(--color-apropos-section-1, #17A2B8)}
.bg-color-apropos-section-2 {background-color: var(--color-apropos-section-2, #D46A6A)}
.bg-color-apropos-section-3 {background-color: var(--color-apropos-section-3, #28A745)}
.bg-color-apropos-section-4 {background-color: var(--color-apropos-section-4, #E83E8C)}
.bg-color-apropos-section-5 {background-color: var(--color-apropos-section-5, #20C997)}
/* End Colors */
section{}

</style>



// WEBPACK FOOTER //
// src/App.vue